import paymentDataSchema from './paymentData.schema';

export default {
  type: 'object',
  properties: {
    data: {
      properties: {
        contractorId: {
          type: 'number',
          title: 'ID kontrahenta KSAT'
        },

        contractorAddressId: {
          type: 'number',
          title: 'ID adresu KSAT'
        },

        contractorBankAccountId: {
          type: 'number',
          title: 'ID konta bankowego KSAT'
        },

        contractor: paymentDataSchema.properties.data.properties.bankAccountOwner
      },
      type: 'object'
    },

    id: { type: 'number' },

    packId: {
      type: 'number',
      title: 'Id paczki'
    }
  }
};
